module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    attrs: {
      "id": "cookienotice"
    }
  }, [_c('div', {
    attrs: {
      "id": "cookietopbar"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "insidecookie"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('layout.cookie.message')) + "\n        "), _c('div', {
    staticClass: "accept",
    on: {
      "click": _vm.acceptCookie
    }
  }, [_c('span', [_vm._v("\n                > " + _vm._s(_vm.$t('layout.cookie.yes')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "decline",
    on: {
      "click": _vm.goAway
    }
  }, [_c('span', [_vm._v("\n                > " + _vm._s(_vm.$t('layout.cookie.no')) + "\n            ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b412553"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/layout/cookie-notice.vue
// module id = 314
// module chunks = 1